import { __extends } from "tslib";
import MultiplePathMask from './path';
import { getMaskPath, getMaskAttrs } from '../smooth-path';
/**
 * Smooth path mask
 * @ignore
 */
var SmoothPathMultiMask = /** @class */ (function (_super) {
    __extends(SmoothPathMultiMask, _super);
    function SmoothPathMultiMask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getMaskPath = getMaskPath;
        _this.getMaskAttrs = getMaskAttrs;
        return _this;
    }
    return SmoothPathMultiMask;
}(MultiplePathMask));
export default SmoothPathMultiMask;
//# sourceMappingURL=smooth-path.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g2/esm/interaction/action/mask/multiple/smooth-path.js
// module id = null
// module chunks = 